var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "sig-preview" }, [
    _vm.field.label !== false
      ? _c("div", { staticClass: "sig-preview__label" }, [
          _vm._v("\n    " + _vm._s(_vm.field.label || "Signature") + "\n    "),
          _vm.field.required === "yes"
            ? _c("span", { staticClass: "sig-preview__required" }, [
                _vm._v(" *")
              ])
            : _vm._e()
        ])
      : _vm._e(),
    _vm._v(" "),
    _c("div", { staticClass: "sig-preview__pad" }, [
      _c("div", { staticClass: "sig-preview__hint" }, [
        _c(
          "svg",
          {
            staticClass: "sig-preview__pen-icon",
            attrs: {
              viewBox: "0 0 24 24",
              fill: "none",
              stroke: "currentColor",
              "stroke-width": "1.5",
              "stroke-linecap": "round",
              "stroke-linejoin": "round"
            }
          },
          [
            _c("path", { attrs: { d: "M12 20h9" } }),
            _vm._v(" "),
            _c("path", {
              attrs: {
                d: "M16.5 3.5a2.121 2.121 0 0 1 3 3L7 19l-4 1 1-4L16.5 3.5z"
              }
            })
          ]
        ),
        _vm._v(" "),
        _c("span", [_vm._v("Sign here")])
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "sig-preview__baseline" })
    ]),
    _vm._v(" "),
    _vm._m(0),
    _vm._v(" "),
    _vm.field.help
      ? _c("div", {
          staticClass: "sig-preview__help",
          domProps: { innerHTML: _vm._s(_vm.field.help) }
        })
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "sig-preview__footer" }, [
      _c("span", { staticClass: "sig-preview__clear" }, [
        _c("i", { staticClass: "el-icon-refresh-left" }),
        _vm._v(" Clear\n    ")
      ])
    ])
  }
]
render._withStripped = true

export { render, staticRenderFns }